import {
  PolicyContainer,
  PolicyTitle,
  PolicyVersion,
  PolicyText,
  PolicySectionTitle,
  PolicyArticleTitle,
  PolicyHyphenList,
} from "styles/PolicyCommon";
import { useEffect } from "react";

const OperationTh = () => {
  useEffect(() => {
    document.documentElement.lang = "th";
    document.title = "pregnancy&baby";
    return () => {
      document.documentElement.lang = "en";
      document.title = "pregnancy&baby";
    };
  }, []);

  return (
    <PolicyContainer>
      <h1 className="hide">pregnancy&amp;baby</h1>
      <PolicyTitle>แนวทางชุมชนของ pregnancy&baby</PolicyTitle>
      <PolicyVersion>
        วันที่มีผลบังคับใช้: 21 กันยายน 2026
        <br />
        ปรับปรุงล่าสุด: 25 สิงหาคม 2026
      </PolicyVersion>

      <PolicyText>
        แนวทางชุมชนฉบับนี้ (“แนวทาง”)
        กำหนดกฎและมาตรฐานสำหรับการใช้ฟีเจอร์ชุมชนของ{" "}
        <strong>pregnancy&baby</strong> ซึ่งดำเนินการโดย Connecti Co., Ltd.
        (“บริษัท”, “เรา” หรือ “ของเรา”)
      </PolicyText>
      <PolicyText>
        ชุมชนของ pregnancy&baby เป็นพื้นที่ที่ผู้ใช้สามารถแบ่งปันประสบการณ์
        ความกังวล คำถาม และข้อมูลเกี่ยวกับการเตรียมตัวตั้งครรภ์
        การรักษาภาวะมีบุตรยาก การตั้งครรภ์ การคลอดบุตร การเลี้ยงดูบุตร
        และหัวข้ออื่น ๆ
      </PolicyText>
      <PolicyText>
        เราต้องการให้ pregnancy&baby เป็นพื้นที่ที่ปลอดภัย เป็นมิตร
        และให้เกียรติซึ่งกันและกัน เพื่อให้ผู้ใช้สามารถพูดคุย
        แลกเปลี่ยนประสบการณ์ และช่วยเหลือกันได้อย่างสบายใจ
        โปรดอ่านและปฏิบัติตามแนวทางฉบับนี้เมื่อใช้ฟีเจอร์ชุมชน
      </PolicyText>
      <PolicyText>
        แนวทางฉบับนี้เป็นส่วนเสริมของ{" "}
        <strong>ข้อกำหนดการใช้บริการ pregnancy&baby</strong>{" "}
        หากกิจกรรมของผู้ใช้ฝ่าฝืนกฎหมายที่ใช้บังคับ ข้อกำหนดการใช้บริการ
        หรือแนวทางฉบับนี้ บริษัทอาจดำเนินมาตรการที่เหมาะสม เช่น
        จำกัดหรือลบเนื้อหา หรือจำกัดการใช้ฟีเจอร์ชุมชน
      </PolicyText>
      <PolicyText>
        บริษัทอาจแก้ไขแนวทางฉบับนี้เมื่อมีความจำเป็นเพื่อรักษาสภาพแวดล้อมของชุมชนให้ปลอดภัยและเหมาะสม
        การเปลี่ยนแปลงที่สำคัญจะได้รับการแจ้งล่วงหน้าผ่านบริการตามข้อกำหนดการใช้บริการและกฎหมายที่ใช้บังคับ
      </PolicyText>

      <PolicySectionTitle>1. โปรไฟล์ของคุณเป็นตัวแทนของคุณ</PolicySectionTitle>
      <PolicyText>
        ชื่อเล่นและรูปโปรไฟล์ช่วยให้ผู้ใช้อื่นสามารถระบุตัวคุณภายในชุมชนได้
      </PolicyText>
      <PolicyText>
        โปรดใช้ข้อมูลโปรไฟล์ที่เหมาะสมและสะท้อนถึงตัวตนของคุณ
      </PolicyText>
      <PolicyText>โปรไฟล์อาจถูกจำกัดหรือขอให้แก้ไข หาก:</PolicyText>
      <PolicyHyphenList>
        <li>
          มีเนื้อหาหรือรูปภาพที่ไม่เหมาะสม ก่อให้เกิดความไม่สบายใจ ลามก
          หรือผิดกฎหมาย{" "}
        </li>
        <li>
          ใช้ชื่อ เครื่องหมายการค้า โลโก้ รูปภาพ
          หรือเนื้อหาที่ได้รับการคุ้มครองของบุคคลหรือองค์กรอื่นโดยไม่ได้รับอนุญาต{" "}
        </li>
        <li>
          แอบอ้างเป็นบุคคลอื่น บริษัท องค์กร พนักงานหรือผู้ดูแลของ
          pregnancy&baby{" "}
        </li>
        <li>
          หรืออาจทำให้ผู้ใช้อื่นเข้าใจผิดหรือสับสนเกี่ยวกับตัวตนหรือสถานะของผู้ใช้
        </li>
      </PolicyHyphenList>

      <PolicySectionTitle>2. การโพสต์ในชุมชน</PolicySectionTitle>
      <PolicyText>
        เนื้อหาที่โพสต์ในชุมชน pregnancy&baby อาจถูกมองเห็นได้โดยสมาชิกคนอื่น
      </PolicyText>
      <PolicyText>
        ก่อนโพสต์ โปรดตรวจสอบว่าบทความ ความคิดเห็น รูปภาพ
        หรือเนื้อหาของคุณไม่มีข้อมูลส่วนบุคคล ข้อมูลส่วนตัว
        หรือข้อมูลที่มีความอ่อนไหวที่คุณไม่ต้องการเปิดเผย
      </PolicyText>
      <PolicyText>
        โพสต์ ความคิดเห็น ข้อมูลโปรไฟล์ รูปภาพ
        และเนื้อหาอื่นทั้งหมดต้องเป็นไปตามแนวทางฉบับนี้และข้อกำหนดการใช้บริการ
        pregnancy&baby
      </PolicyText>

      <PolicySectionTitle>3. การรายงานเนื้อหาที่ไม่เหมาะสม</PolicySectionTitle>
      <PolicyText>
        หากคุณพบโพสต์หรือความคิดเห็นที่คิดว่าฝ่าฝืนแนวทางฉบับนี้ เช่น สแปม
        โฆษณาที่ไม่ได้รับอนุญาต การคุกคาม การด่าทอ หรือเนื้อหาไม่เหมาะสมอื่น
        คุณสามารถใช้ฟีเจอร์ รายงาน ภายในบริการ
      </PolicyText>
      <PolicyText>
        การรายงานจากผู้ใช้ช่วยให้เราสามารถรักษาชุมชนให้ปลอดภัยและน่าใช้งานมากขึ้น
      </PolicyText>
      <PolicyText>
        บริษัทอาจตรวจสอบเนื้อหาที่ได้รับรายงานและดำเนินมาตรการที่เหมาะสมตามแนวทางฉบับนี้
        ข้อกำหนดการใช้บริการ และกฎหมายที่ใช้บังคับ
      </PolicyText>

      <PolicySectionTitle>4. เนื้อหาและพฤติกรรมที่ห้าม</PolicySectionTitle>
      <PolicyText>
        ห้ามโพสต์หรือกระทำสิ่งต่อไปนี้ในชุมชน pregnancy&baby
      </PolicyText>

      <PolicyArticleTitle>4.1 เนื้อหาทางเพศหรือลามกอนาจาร</PolicyArticleTitle>
      <PolicyText>ห้ามโพสต์เนื้อหาที่:</PolicyText>
      <PolicyHyphenList>
        <li>
          มีคำบรรยายหรือภาพทางเพศที่โจ่งแจ้งมากเกินไป ลามก หรือไม่เหมาะสม{" "}
        </li>
        <li>
          ส่งเสริม ชักชวน เป็นนายหน้า
          หรืออำนวยความสะดวกให้แก่การค้าประเวณีหรือบริการทางเพศที่ผิดกฎหมาย{" "}
        </li>
        <li>
          มีจุดประสงค์เพื่อทำให้อื่นอับอายทางเพศ คุกคาม หรือทำให้ไม่สบายใจ{" "}
        </li>
        <li>
          มีเนื้อหาเกี่ยวกับการแสวงหาประโยชน์ทางเพศ
          หรือเนื้อหาทางเพศอื่นที่ผิดกฎหมาย
        </li>
      </PolicyHyphenList>

      <PolicyArticleTitle>
        4.2 กิจกรรมหรือการซื้อขายที่ผิดกฎหมาย
      </PolicyArticleTitle>
      <PolicyText>ห้ามใช้ชุมชนเพื่อ:</PolicyText>
      <PolicyHyphenList>
        <li>ส่งเสริมหรืออำนวยความสะดวกให้แก่การพนันที่ผิดกฎหมาย </li>
        <li>
          ซื้อ ขาย แลกเปลี่ยน
          หรือชักชวนให้ซื้อขายสินค้าและบริการที่ผิดกฎหมาย{" "}
        </li>
        <li>ขายหรือโฆษณาสินค้าที่กฎหมายห้ามจำหน่ายทางออนไลน์ </li>
        <li>
          ให้ข้อมูลที่มีจุดประสงค์เพื่อส่งเสริม สนับสนุน
          หรือช่วยให้เกิดการกระทำที่ผิดกฎหมาย
        </li>
      </PolicyHyphenList>

      <PolicyArticleTitle>
        4.3 เนื้อหาที่เป็นอันตราย รุนแรง หรือสร้างความไม่สบายใจ
      </PolicyArticleTitle>
      <PolicyText>ห้ามโพสต์เนื้อหาที่:</PolicyText>
      <PolicyHyphenList>
        <li>
          แสดงภาพหรือคำบรรยายที่รุนแรง น่าสยดสยอง หรือสร้างความไม่สบายใจอย่างมาก
          เช่น
          ภาพร่างกายที่ได้รับบาดเจ็บอย่างรุนแรงหรือภาพการเสียชีวิตที่โจ่งแจ้ง{" "}
        </li>
        <li>เกี่ยวข้องกับหรืออำนวยความสะดวกให้แก่การแสวงหาประโยชน์ทางเพศ </li>
        <li>
          ข่มขู่ บังคับ หลอกล่อ
          หรือชักจูงบุคคลอื่นเพื่อวัตถุประสงค์ในการแสวงหาประโยชน์ทางเพศ{" "}
        </li>
        <li>ส่งเสริม ยกย่อง หรือสนับสนุนความรุนแรง </li>
        <li>
          ส่งเสริมการเลือกปฏิบัติ ความเกลียดชัง หรืออคติต่อบุคคลหรือกลุ่มบุคคล
          เนื่องจากสัญชาติ ถิ่นกำเนิด เชื้อชาติ รูปลักษณ์ ความพิการ โรค เพศ
          อัตลักษณ์ทางเพศ รสนิยมทางเพศ หรือคุณลักษณะส่วนบุคคลอื่น{" "}
        </li>
        <li>
          ส่งเสริม สนับสนุน หรือชักชวนให้มีการฆ่าตัวตายหรือการฆ่าตัวตายหมู่
        </li>
      </PolicyHyphenList>

      <PolicyArticleTitle>
        4.4 การโฆษณา การประชาสัมพันธ์ และการชักชวน
      </PolicyArticleTitle>
      <PolicyText>
        การโฆษณาเชิงพาณิชย์ การประชาสัมพันธ์ การขาย การชักชวน
        หรือสแปมที่ไม่ได้รับอนุญาตจากบริษัท อาจถูกจำกัดหรือลบ
      </PolicyText>
      <PolicyText>รวมถึงแต่ไม่จำกัดเพียง:</PolicyText>
      <PolicyHyphenList>
        <li>การโพสต์โฆษณาหรือประชาสัมพันธ์ที่เหมือนหรือคล้ายกันซ้ำ ๆ </li>
        <li>โพสต์ที่มีวัตถุประสงค์หลักเพื่อโฆษณาสินค้าหรือบริการ </li>
        <li>
          เนื้อหาที่มีจุดประสงค์เพื่อนำผู้ใช้ไปยังการซื้อขายหรือกิจกรรมเชิงพาณิชย์ภายนอกที่ไม่ได้รับอนุญาต{" "}
        </li>
        <li>การใช้ชุมชนเป็นหลักเพื่อการขายสินค้า หาลูกค้า หรือทำการตลาด</li>
      </PolicyHyphenList>
      <PolicyText>
        บริษัทไม่ได้มีส่วนร่วม รับรอง
        หรือรับประกันธุรกรรมที่ผู้ใช้ดำเนินการกันเองโดยสมัครใจอันเกิดจากโพสต์หรือการติดต่อภายในชุมชน
      </PolicyText>
      <PolicyText>
        หากพบกิจกรรมทางการค้าหรือการประชาสัมพันธ์ที่น่าสงสัย
        โปรดใช้ฟีเจอร์รายงานภายในบริการ
      </PolicyText>

      <PolicyArticleTitle>
        4.5 การคุกคาม การดูหมิ่น การหมิ่นประมาท และการแอบอ้าง
      </PolicyArticleTitle>
      <PolicyText>ห้าม:</PolicyText>
      <PolicyHyphenList>
        <li>ดูหมิ่น ข่มขู่ คุกคาม หรือโจมตีบุคคลอื่นซ้ำ ๆ </li>
        <li>
          ใช้ถ้อยคำหยาบคาย เหยียดหยาม หรือก้าวร้าวอย่างรุนแรงกับผู้ใช้อื่น{" "}
        </li>
        <li>
          แอบอ้างเป็น pregnancy&baby บริษัท พนักงาน ผู้ดูแล หรือบุคคลอื่น{" "}
        </li>
        <li>
          ให้ข้อมูลอันเป็นเท็จเกี่ยวกับตัวตนหรือสถานะเพื่อหลอกลวงผู้ใช้อื่นหรือแสวงหาประโยชน์ที่ไม่เหมาะสม{" "}
        </li>
        <li>
          จงใจเผยแพร่ข้อมูลเท็จหรือทำให้เข้าใจผิดเกี่ยวกับบุคคลหรือองค์กรในลักษณะที่อาจทำให้เกิดความเสียหาย{" "}
        </li>
        <li>
          เผยแพร่เนื้อหาปลอมในลักษณะที่ทำให้ผู้ใช้อาจเข้าใจผิดว่าเป็นข่าว รายงาน
          หรือข้อมูลทางการจริง
        </li>
      </PolicyHyphenList>

      <PolicyArticleTitle>4.6 มัลแวร์และการรบกวนบริการ</PolicyArticleTitle>
      <PolicyText>ห้าม:</PolicyText>
      <PolicyHyphenList>
        <li>
          อัปโหลด แจกจ่าย หรือลิงก์ไปยังไวรัส มัลแวร์ โค้ดอันตราย
          หรือโปรแกรมอื่นที่มีวัตถุประสงค์เพื่อทำลายหรือรบกวนอุปกรณ์หรือระบบ{" "}
        </li>
        <li>แทรกแซงหรือรบกวนการดำเนินงานปกติของ pregnancy&baby </li>
        <li>ใช้ประโยชน์จากช่องโหว่ของบริการ </li>
        <li>
          ใช้วิธีอัตโนมัติหรือวิธีที่ไม่ได้รับอนุญาตเพื่อเผยแพร่โฆษณา
          เนื้อหาส่งเสริมการขาย คำขอเป็นเพื่อน คำขอให้มีส่วนร่วม
          หรือเนื้อหาในลักษณะเดียวกัน
        </li>
      </PolicyHyphenList>

      <PolicyArticleTitle>4.7 การละเมิดทรัพย์สินทางปัญญา</PolicyArticleTitle>
      <PolicyText>โปรดเคารพสิทธิในทรัพย์สินทางปัญญาของผู้อื่น</PolicyText>
      <PolicyText>ห้าม:</PolicyText>
      <PolicyHyphenList>
        <li>
          ใช้ผลงาน ลิขสิทธิ์ เครื่องหมายการค้า การออกแบบ รูปภาพ
          หรือเนื้อหาที่ได้รับการคุ้มครองของผู้อื่นโดยไม่ได้รับอนุญาต{" "}
        </li>
        <li>
          แชร์รายการออกอากาศ เพลง ภาพยนตร์ แอนิเมชัน ภาพถ่าย รูปภาพ บทความ โพสต์
          หรือผลงานอื่นโดยไม่ได้รับอนุญาตอย่างเหมาะสม{" "}
        </li>
        <li>
          ให้คำแนะนำหรือข้อมูลที่มีวัตถุประสงค์เพื่อช่วยให้เข้าถึงหรือใช้ผลงานที่มีลิขสิทธิ์โดยผิดกฎหมาย{" "}
        </li>
        <li>
          คัดลอกหรือนำโพสต์ ภาพถ่าย หรือรูปภาพของผู้ใช้ pregnancy&baby
          คนอื่นไปเผยแพร่ซ้ำโดยไม่ได้รับอนุญาต
          หากการกระทำนั้นละเมิดสิทธิของเจ้าของผลงาน
        </li>
      </PolicyHyphenList>

      <PolicyArticleTitle>
        4.8 ข้อมูลส่วนบุคคลและการชักชวนให้ออกไปสนทนานอกบริการ
      </PolicyArticleTitle>
      <PolicyText>
        เพื่อคุ้มครองความเป็นส่วนตัวและความปลอดภัยของผู้ใช้ ห้าม:
      </PolicyText>
      <PolicyHyphenList>
        <li>ขอข้อมูลส่วนบุคคลของผู้ใช้อื่นผ่านโพสต์หรือความคิดเห็น </li>
        <li>
          เปิดเผยข้อมูลส่วนบุคคลของตนเองหรือของผู้อื่นต่อสาธารณะในลักษณะที่อาจก่อให้เกิดความเสี่ยงด้านความเป็นส่วนตัวหรือความปลอดภัย{" "}
        </li>
        <li>
          ชักชวนผู้ใช้อื่นซ้ำ ๆ
          หรืออย่างไม่เหมาะสมให้ย้ายการสนทนาไปยังโซเชียลมีเดีย แอปส่งข้อความ
          หรือช่องทางภายนอกบริการ
        </li>
      </PolicyHyphenList>
      <PolicyText>
        เมื่อแชร์ข้อมูลในชุมชน
        โปรดทราบว่าสมาชิกคนอื่นอาจสามารถดูข้อมูลดังกล่าวได้
      </PolicyText>

      <PolicyArticleTitle>4.9 สแปมและพฤติกรรมก่อกวนชุมชน</PolicyArticleTitle>
      <PolicyText>ห้าม:</PolicyText>
      <PolicyHyphenList>
        <li>โพสต์เนื้อหาที่เหมือนหรือมีสาระสำคัญเหมือนกันซ้ำ ๆ </li>
        <li>โพสต์เนื้อหาเดียวกันหรือคล้ายกันในหลายส่วนของบริการ </li>
        <li>บิดเบือนหรือใช้ฟีเจอร์ของบริการในทางที่ผิด </li>
        <li>จงใจขัดขวางการใช้บริการตามปกติของผู้ใช้อื่น </li>
        <li>
          หรือกระทำการอื่นที่รบกวนการดำเนินงานตามปกติของชุมชนอย่างมีนัยสำคัญ
        </li>
      </PolicyHyphenList>
      <PolicyText>
        แม้พฤติกรรมใดจะไม่ได้ระบุไว้อย่างชัดเจนในแนวทางฉบับนี้ ก็อาจถูกจำกัดได้
        หากพฤติกรรมนั้นอย่างชัดเจนเป็นอันตรายต่อความปลอดภัย ความเหมาะสม
        หรือการดำเนินงานตามปกติของบริการ
        หรือรบกวนการใช้บริการของผู้ใช้อื่นอย่างมีนัยสำคัญ
      </PolicyText>

      <PolicySectionTitle>5. การตรวจสอบและจัดการเนื้อหา</PolicySectionTitle>
      <PolicyText>
        หากเนื้อหาฝ่าฝืนกฎหมายที่ใช้บังคับ ข้อกำหนดการใช้บริการ pregnancy&baby
        หรือแนวทางฉบับนี้ บริษัทอาจดำเนินมาตรการหนึ่งหรือหลายอย่างดังต่อไปนี้
      </PolicyText>
      <PolicyHyphenList>
        <li>จำกัดการมองเห็นของเนื้อหา </li>
        <li>ซ่อนเนื้อหาเป็นการชั่วคราว </li>
        <li>ลบเนื้อหา </li>
        <li>จำกัดฟีเจอร์การโพสต์หรือแสดงความคิดเห็น </li>
        <li>จำกัดการเข้าถึงฟีเจอร์ชุมชนบางส่วน </li>
        <li>
          ดำเนินมาตรการอื่นที่จำเป็นอย่างสมเหตุสมผลเพื่อป้องกันการฝ่าฝืนต่อเนื่องหรือความเสียหายเพิ่มเติม{" "}
        </li>
      </PolicyHyphenList>
      <PolicyText>
        บริษัทไม่มีหน้าที่ต้องตรวจสอบเนื้อหาทั้งหมดของผู้ใช้ก่อนเผยแพร่
      </PolicyText>
      <PolicyText>
        การที่เนื้อหาบางรายการยังคงปรากฏอยู่ในบริการ
        ไม่ได้หมายความว่าบริษัทได้อนุมัติ รับรอง ตรวจสอบ
        หรือยืนยันความถูกต้องของเนื้อหาดังกล่าว
      </PolicyText>

      <PolicySectionTitle>6. การจำกัดบัญชีและการใช้บริการ</PolicySectionTitle>
      <PolicyText>
        หากผู้ใช้ฝ่าฝืนกฎหมายที่ใช้บังคับ ข้อกำหนดการใช้บริการ หรือแนวทางฉบับนี้
        บริษัทอาจจำกัดการเข้าถึงฟีเจอร์หรือบริการบางส่วน
      </PolicyText>
      <PolicyText>
        มาตรการจำกัดอาจเป็นการชั่วคราวหรือถาวร ขึ้นอยู่กับลักษณะ ความร้ายแรง
        และความถี่ของการฝ่าฝืน
      </PolicyText>
      <PolicyText>มาตรการที่บริษัทอาจดำเนินการ ได้แก่:</PolicyText>
      <PolicyHyphenList>
        <li>การตักเตือน </li>
        <li>การจำกัดการมองเห็นของเนื้อหา </li>
        <li>การลบเนื้อหา </li>
        <li>การจำกัดการโพสต์หรือแสดงความคิดเห็นเป็นการชั่วคราว </li>
        <li>การจำกัดการใช้ฟีเจอร์ชุมชน </li>
        <li>การระงับบัญชีชั่วคราว </li>
        <li>การจำกัดหรือระงับบัญชีอย่างถาวรในกรณีที่มีการฝ่าฝืนอย่างร้ายแรง</li>
      </PolicyHyphenList>
      <PolicyText>
        บริษัทอาจดำเนินมาตรการที่จำเป็นได้ทันทีโดยไม่ต้องใช้ขั้นตอนการจำกัดแบบลำดับ
        หากเป็นกรณีที่เกี่ยวข้องกับการกระทำผิดกฎหมายอย่างร้ายแรง
        การแสวงหาประโยชน์ทางเพศ การพนันผิดกฎหมาย ความเสี่ยงร้ายแรงต่อความปลอดภัย
        การโจมตีบริการโดยมีเจตนาร้าย หรือการฝ่าฝืนอย่างร้ายแรงอื่น
      </PolicyText>
      <PolicyText>
        บริษัทอาจดำเนินมาตรการป้องกันที่สมเหตุสมผล
        หากตรวจพบกิจกรรมบัญชีที่ผิดปกติ ความพยายามเข้าถึงโดยไม่ได้รับอนุญาต
        การใช้งานอัตโนมัติในทางที่ผิด
        หรือกิจกรรมอื่นที่อาจเป็นภัยต่อผู้ใช้หรือบริการ
      </PolicyText>

      <PolicySectionTitle>7. การขอให้ตรวจสอบอีกครั้ง</PolicySectionTitle>
      <PolicyText>
        หากคุณเชื่อว่าเนื้อหาหรือบัญชีของคุณถูกจำกัดโดยความผิดพลาด
        คุณสามารถติดต่อฝ่ายบริการลูกค้าของ pregnancy&baby
        เพื่อขอให้ตรวจสอบอีกครั้ง
      </PolicyText>
      <PolicyText>
        บริษัทจะพิจารณาคำขอตามแนวทางฉบับนี้ ข้อกำหนดการใช้บริการ
        และกฎหมายที่ใช้บังคับ
      </PolicyText>
      <PolicyText>
        <strong>ฝ่ายบริการลูกค้า: after10month@connect-i.co.kr</strong>
      </PolicyText>

      <PolicySectionTitle>
        8. ความสัมพันธ์กับข้อกำหนดการใช้บริการ
      </PolicySectionTitle>
      <PolicyText>
        แนวทางฉบับนี้เป็นส่วนหนึ่งของกฎที่ใช้กับการใช้งาน pregnancy&baby
        และให้อ่านและใช้ร่วมกับ{" "}
        <strong>ข้อกำหนดการใช้บริการ pregnancy&baby</strong>
      </PolicyText>
      <PolicyText>
        สำหรับเรื่องที่ไม่ได้ระบุไว้โดยเฉพาะในแนวทางฉบับนี้
        ให้ดำเนินการตามข้อกำหนดการใช้บริการ กฎหมายที่ใช้บังคับ
        และนโยบายอื่นที่เกี่ยวข้องของบริษัท
      </PolicyText>
    </PolicyContainer>
  );
};

export default OperationTh;
